/**
 * The one HTTP client for the Business Profile routes (XC-ERP1-U3 §5.1): the read
 * (`businessProfileService`) and the writes (`businessProfileWrites`, ERP1-P2-BP-EDIT).
 *
 * Routed through the gateway (`/api/v1/business-profile*` → entity_resolution). The tenant and
 * the acting user are always the JWT's: no call carries a tenant id or a user id, and the
 * operator Pipeline tenant override is never attached.
 */

import { config } from '@/config/environment';
import { getAuthToken } from '@/contexts/AuthContext';
import axios from 'axios';

export const businessProfileApi = axios.create({
  baseURL: config.GATEWAY_URL,
  timeout: 30_000,
  headers: { 'Content-Type': 'application/json' },
});

businessProfileApi.interceptors.request.use((reqConfig) => {
  const token = getAuthToken();
  if (token) {
    reqConfig.headers.Authorization = `Bearer ${token}`;
  }
  return reqConfig;
});
